








import React, { useState } from 'react';


const HireDedicatedTeam = () => {
  const [processOpen, setProcessOpen] = useState(1);
  const [faqOpen, setFaqOpen] = useState(1);

  const processSteps = [
    {
      title: '01. Needs Assessment',
      body: 'We work with you to define team size, roles, skills, and responsibilities needed.'
    },
    {
      title: '02. Talent Sourcing',
      body: 'We source and screen candidates from our network of pre-vetted professionals.'
    },
    {
      title: '03. Team Integration',
      body: 'Your dedicated team is onboarded into your tools, workflows, and culture.'
    },
    {
      title: '04. Ongoing Collaboration',
      body: 'We provide continuous communication, reporting, and performance management.'
    }
  ];

  const faqList = [
    {
      q: 'Is there a minimum contract or hourly block?',
      a: 'No long-term lock-in. Billing is month-to-month with a 40-hour minimum. Unused hours roll forward for 30 days, so you never lose paid time.'
    },
    {
      q: 'Can I scale the team up or down fast?',
      a: 'Yes. Add or pause assistants with 24-hour notice—perfect for seasonal peaks or project sprints. Your account manager handles onboarding and off-boarding paperwork.'
    },
    {
      q: 'What if I’m unhappy with task quality?',
      a: 'You get a dedicated QA lead who scores work daily. If accuracy ever drops below 98%, we retrain or replace the VA at no extra cost within one business day.'
    },
    {
      q: 'Do you work in my time zone?',
      a: 'We staff assistants in US and APAC zones and can provide blended coverage for 24/7 support. Just tell us your preferred hours during onboarding.'
    },
    {
      q: 'How is communication handled?',
      a: 'Your VA is available in Slack, Teams or email—your choice. Weekly 15-minute stand-ups and a live dashboard keep you updated on task status and KPIs.'
    }
  ];

  return (
    <div className="page_wrapper">

      <main className="page_content">
        {/* Page Banner Section */}
        <section className="page_banner_section text-center" style={{ backgroundImage: "url('/assets/images/shapes/bg_pattern_3.svg')",marginTop: '90px' }}>
          <div className="container">
            <div className="heading_focus_text text-white">
              Service <span className="badge bg-secondary">Details </span>
            </div>
            <h1 className="page_title mb-0 text-white">Hire Dedicated Teams</h1>
          </div>
        </section>

        {/* Service Details Section */}
        <section className="service_details_section section_space bg-light">
          <div className="container">
            <div className="details_item_image position-relative">
              <img src="/assets/images/service-details/Hire Dedicated Teams.jpg" alt="Hire Dedicated Teams Service" />
            </div>
            <h2 className="details_item_title">Hire Dedicated Teams</h2>
            <p>
              Our Hire Dedicated Teams service provides you with full-time professionals who work exclusively for your business as an extension of your in-house staff.
              Whether you need developers, designers, marketers, or support agents, we assemble a team tailored to your specific requirements.
              This ensures focus, accountability, and long-term alignment with your goals.
            </p>
            <p>
              Unlike freelancers or short-term contractors, dedicated teams are committed solely to your projects,
              ensuring faster delivery, deeper product knowledge, and strong integration with your processes and culture.
            </p>

            <h3 className="details_item_info_title">Service Process</h3>
            <div className="row mb-5 align-items-center justify-content-lg-between">
              <div className="col-lg-6">
                <div className="accordion" id="service_process_faq_dedicated">
                  {processSteps.map((step, idx) => (
                    <div className="accordion-item" key={idx}>
                      <div
                        className={`accordion-button${processOpen === idx + 1 ? '' : ' collapsed'}`}
                        role="button"
                        onClick={() => setProcessOpen(processOpen === idx + 1 ? null : idx + 1)}
                        aria-expanded={processOpen === idx + 1}
                        aria-controls={`dedicated_${idx}`}
                        data-bs-toggle="collapse"
                        data-bs-target={`#dedicated_${idx}`}
                      >
                        {step.title}
                      </div>
                      <div
                        id={`dedicated_${idx}`}
                        className={`accordion-collapse collapse${processOpen === idx + 1 ? ' show' : ''}`}
                        data-bs-parent="#service_process_faq_dedicated"
                      >
                        <div className="accordion-body">
                          <p className="m-0">{step.body}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-lg-5">
                <ul className="content_layer_group unordered_list_block text-center">
                  {processSteps.map((step, idx) => (
                    <li
                      className={`accordion-button${processOpen === idx + 1 ? '' : ' collapsed'}`}
                      key={idx}
                      onClick={() => setProcessOpen(processOpen === idx + 1 ? null : idx + 1)}
                      data-bs-toggle="collapse"
                      data-bs-target={`#dedicated_${idx}`}
                    >
                      <span>{step.title.replace(/^\d+\. /, '')}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <h3 className="details_item_info_title">What's Included</h3>
            <div className="row mb-4">
              <div className="col-lg-6">
                <ul className="icon_list unordered_list_block">
                  <li>
                    <span className="icon_list_icon"><img src="/assets/images/icons/icon_check_3.svg" alt="Check Icon" /></span>
                    <span className="icon_list_text">Full-time dedicated professionals</span>
                  </li>
                  <li>
                    <span className="icon_list_icon"><img src="/assets/images/icons/icon_check_3.svg" alt="Check Icon" /></span>
                    <span className="icon_list_text">Custom team structure & skill sets</span>
                  </li>
                </ul>
              </div>
              <div className="col-lg-6">
                <ul className="icon_list unordered_list_block">
                  <li>
                    <span className="icon_list_icon"><img src="/assets/images/icons/icon_check_3.svg" alt="Check Icon" /></span>
                    <span className="icon_list_text">Seamless integration into your workflows</span>
                  </li>
                  <li>
                    <span className="icon_list_icon"><img src="/assets/images/icons/icon_check_3.svg" alt="Check Icon" /></span>
                    <span className="icon_list_text">Dedicated account & project managers</span>
                  </li>
                </ul>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src="/assets/images/services-images/Dedicated-1.jpg" alt="Dedicated Team at Work" />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src="/assets/images/services-images/Dedicated-2.jpg" alt="Team Integration" />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-6">
                <div className="details_item_image m-0">
                  <img src="/assets/images/services-images/Dedicated-3.jpg" alt="Project Collaboration" />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="faq_section section_decoration">
          <div className="container">
            <div className="heading_block text-center">
              <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: "url('/assets/images/shapes/shape_title_under_line.svg')" }}>
                F.A.Q.
              </div>
              <h2 className="heading_text mb-0">
                Need a <mark>Support?</mark>
              </h2>
            </div>
            <div className="faq_accordion accordion" id="faq_accordion">
              {faqList.map((item, idx) => (
                <div className="accordion-item" key={idx}>
                  <div
                    className={`accordion-button${faqOpen === idx + 1 ? '' : ' collapsed'}`}
                    role="button"
                    onClick={() => setFaqOpen(faqOpen === idx + 1 ? null : idx + 1)}
                    aria-expanded={faqOpen === idx + 1}
                    aria-controls={`collapse_faq_${idx}`}
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse_faq_${idx}`}
                  >
                    Q. {item.q}
                  </div>
                  <div
                    id={`collapse_faq_${idx}`}
                    className={`accordion-collapse collapse${faqOpen === idx + 1 ? ' show' : ''}`}
                    data-bs-parent="#faq_accordion"
                  >
                    <div className="accordion-body">
                      <div className="text_a">A.</div>
                      <p>{item.a}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="decoration_item shape_image_1">
            <img src="/assets/images/shapes/shape_space_4.svg" alt="Shape" />
          </div>
        </section>

        {/* Call To Action Section */}
        <section className="calltoaction_section parallaxie" style={{ backgroundImage: "url('/assets/images/backgrounds/staffing.jpg')" }}>
          <div className="container text-center">
            <div className="heading_block text-white">
              <h2 className="heading_text">
                Ready to Work, Let's Chat
              </h2>
              <p className="heading_description mb-0">
                Our team of experts is ready to collaborate with you every step of the way, from initial consultation to implementation.
              </p>
            </div>
            <a className="btn btn-primary" href="/contact">
              <span className="btn_label" data-text="Contact Us Today!">Contact Us Today!</span>
              <span className="btn_icon">
                <i className="fa-solid fa-arrow-up-right"></i>
              </span>
            </a>
          </div>
        </section>
      </main>

    </div>
  );
};

export default HireDedicatedTeam;
